import { createContext } from 'react'

export interface IAsideMenuContext {
  active?: string
  expand?: string
  onSelect?: (e: any) => void
}

export const AsideMenuContext = createContext<IAsideMenuContext>({ onSelect: () => {} })
